<template>
  <div class="game" @mouseover="onMouseOver" @mouseleave="onMouseLeave" @click="onClick">
    <canvas ref="canvas" style="
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: black;
        left: 0;
        top: 0;
      "></canvas>
  </div>
</template>

<script>
import { Rive, Layout } from '@rive-app/canvas';

export default {
  name: 'RiveGame',
  props: {
    src: String,
    fit: String,
    alignment: String
  },
  data() {
    return {
      riveInstance: null,
      hoverInput: null,
      clickInput: null
    };
  },
  mounted() {
    this.riveInstance = new Rive({
        canvas: this.$refs.canvas,
        src: this.$props.src,
        layout: new Layout({
            fit: this.$props.fit,
            alignment: this.$props.alignment,
        }),
        autoplay: true,
        stateMachines: "State Machine 1",
        onLoad: () => {
            // Prevent a blurry canvas by using the device pixel ratio
            this.riveInstance.resizeDrawingSurfaceToCanvas();
            // this.riveInstance.enableFPSCounter();
        },
        // Asegúrate de usar el nombre correcto de la máquina de estados
    });

    this.riveInstance.on('load', () => {
      console.log("Rive file loaded successfully!");

      const stateMachineInputs = this.riveInstance.stateMachineInputs("State Machine 1");
      if (stateMachineInputs) {
        // Busca los inputs según el nombre configurado en Rive
        this.hoverInput = stateMachineInputs.find(input => input.name === "Hover");
        this.clickInput = stateMachineInputs.find(input => input.name === "Click");
        if (!this.hoverInput) console.error("Hover input not found in the state machine");
        if (!this.clickInput) console.error("Click input not found in the state machine");
      } else {
        console.error("State machine not found or not loaded properly");
      }

      this.riveInstance.play();
    });

    console.log(this.riveInstance);
  },
  methods: {
    onMouseOver() {
      console.log("Mouse over canvas");
      if (this.hoverInput) {
        this.hoverInput.fire(); // Dispara el input de hover
      }
    },
    onMouseLeave() {
      console.log("Mouse leave canvas");
      if (this.hoverInput) {
        this.hoverInput.fire(); // Dispara el input de hover
      }
    },
    onClick() {
      console.log("Canvas clicked");
      if (this.clickInput) {
        this.clickInput.fire(); // Dispara el input de click
      }
    }
  }
}
</script>
